import React from "react";

const BillingWarning = () => (
  <div className="alert alert-warning font-weight-bold">
    <i className="fa fa-exclamation-triangle"></i> Harga BELUM termasuk PPN
  </div>
);

export default BillingWarning;
